import { format } from 'date-fns'
import { useMemo } from 'react'
import type { Matcher } from 'react-day-picker'

import { DateInput } from '@/components/ui/DateInput'
import type { FieldInputProps } from './fieldInputProps'
import { dateRangeMessage, parseIsoDate } from './screenForm'

/** A date held as 'YYYY-MM-DD', bounded by the field's minDate and maxDate. */
export function DateField({ field, value, onChange, id, invalid, disabled }: FieldInputProps<string>) {
  const { minDate, maxDate } = field
  const hidden = useMemo(() => {
    const matchers: Matcher[] = []
    if (minDate) matchers.push({ before: parseIsoDate(minDate) })
    if (maxDate) matchers.push({ after: parseIsoDate(maxDate) })
    return matchers
  }, [minDate, maxDate])
  const date = useMemo(() => (value ? parseIsoDate(value) : undefined), [value])
  const inputProps = useMemo(
    () => ({ id, name: id, disabled, 'aria-invalid': invalid || undefined }),
    [id, disabled, invalid]
  )

  return (
    <DateInput
      value={date}
      onChange={(date) => onChange(date ? format(date, 'yyyy-MM-dd') : '')}
      hidden={hidden}
      defaultMonth={date ?? (minDate ? parseIsoDate(minDate) : undefined)}
      errorMessage={dateRangeMessage(field)}
      inputProps={inputProps}
    />
  )
}
